import flatpickr from 'flatpickr'
import { Polish } from 'flatpickr/dist/l10n/pl.js'

if (document.querySelector('input[type="date"]')) {
  const elements = document.querySelectorAll('input[type="date"]')

  flatpickr.localize(Polish)
  elements.forEach((element) => {
    flatpickr(element, {
      locale: Polish,
      dateFormat: 'd/m/Y',
      positionElement: element,
      position: 'above center',
      mode: 'range',
      showMonths: 2,
      minDate: 'today',
    })
  })
}
